// utils/chartTimeUtils.js
export const chartTimeConfig = {
	scales: {
		x: {
			type: "time",
			time: {
				unit: "minute",
				tooltipFormat: "yyyy-MM-dd HH:mm:ss",
				displayFormats: {
					minute: "HH:mm",
					hour: "HH:mm",
					day: "MMM dd",
				},
			},
			adapters: {
				date: {
					locale: "it",
				},
			},
			ticks: {
				maxRotation: 0,
				autoSkip: true,
				source: "auto",
				callback: function (value: any, index: any, ticks: any) {
					const date = new Date(value);
					// I dati sono UTC, visualizzali come UTC
					const utcHours = date.getUTCHours().toString().padStart(2, "0");
					const utcMinutes = date.getUTCMinutes().toString().padStart(2, "0");
					return `${utcHours}:${utcMinutes}`;
				},
			},
		},
	},
	plugins: {
		tooltip: {
			callbacks: {
				title: function (context: any) {
					const date = new Date(context[0].parsed.x);
					// Tooltip in UTC (come i dati)
					const year = date.getUTCFullYear();
					const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
					const day = date.getUTCDate().toString().padStart(2, "0");
					const hours = date.getUTCHours().toString().padStart(2, "0");
					const minutes = date.getUTCMinutes().toString().padStart(2, "0");
					const seconds = date.getUTCSeconds().toString().padStart(2, "0");

					return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				},
			},
		},
	},
	interaction: {
		intersect: false,
		mode: "nearest",
		axis: "x",
	},
};

// Versione per ora italiana (UTC+1)
export const chartTimeConfigItalian = {
	scales: {
		x: {
			type: "time",
			time: {
				unit: "minute",
				tooltipFormat: "yyyy-MM-dd HH:mm:ss",
				displayFormats: {
					minute: "HH:mm",
					hour: "HH:mm",
					day: "MMM dd",
				},
			},
			adapters: {
				date: {
					locale: "it",
				},
			},
			ticks: {
				maxRotation: 0,
				autoSkip: true,
				source: "auto",
				// Visualizza in ora italiana (UTC+1)
				callback: function (value: any, index: any, ticks: any) {
					const date = new Date(value);
					let italianHour = date.getUTCHours() + 1;
					if (italianHour >= 24) italianHour -= 24;

					const hours = italianHour.toString().padStart(2, "0");
					const minutes = date.getUTCMinutes().toString().padStart(2, "0");
					return `${hours}:${minutes}`;
				},
			},
		},
	},
	plugins: {
		tooltip: {
			callbacks: {
				title: function (context: any) {
					const date = new Date(context[0].parsed.x);
					// Tooltip in ora italiana (UTC+1)
					let italianHour = date.getUTCHours() + 1;
					let day = date.getUTCDate();
					let month = date.getUTCMonth() + 1;
					let year = date.getUTCFullYear();

					// Gestisci overflow del giorno
					if (italianHour >= 24) {
						italianHour -= 24;
						// Aggiungi 1 giorno
						const nextDay = new Date(date);
						nextDay.setUTCDate(date.getUTCDate() + 1);
						day = nextDay.getUTCDate();
						month = nextDay.getUTCMonth() + 1;
						year = nextDay.getUTCFullYear();
					}

					const hours = italianHour.toString().padStart(2, "0");
					const minutes = date.getUTCMinutes().toString().padStart(2, "0");
					const seconds = date.getUTCSeconds().toString().padStart(2, "0");

					return `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")} ${hours}:${minutes}:${seconds}`;
				},
			},
		},
	},
	interaction: {
		intersect: false,
		mode: "nearest",
		axis: "x",
	},
};

// Funzione per convertire timestamp ISO in millisecondi
export function isoToTimestamp(isoString: string): number {
	return new Date(isoString).getTime();
}
